// Deep search withing an object
function deepSearch(needle, haystack) {
  if (haystack !== null) {
    return Object.values(haystack).some((item) => {
      if (typeof item === 'object') {
        return deepSearch(needle, item);
      }
      if (typeof item === 'string') {
        return item.toLowerCase().includes(needle.toLowerCase());
      }
      return false;
    });
  }
  return false;
}

// Filter resource based on search term
const filterResource = {
  data() {
    return {
      searchString: '',
    };
  },
  methods: {
    filterResource(resource) {
      if (this.searchString.length > 0) {
        return resource.filter(item => deepSearch(this.searchString, item));
      }
      return resource;
    },
  },
};

export default filterResource;



// WEBPACK FOOTER //
// ./src/mixins/filterResource.js